(function() {
    'use strict';
    // ----------------------------------------------------
    // CONTACT COUNT COMPONENT - Displayed under the search bar
    // ----------------------------------------------------
    class ResultCount {
        constructor($scope, $compile){
            this.$compile = $compile;
            this.$scope = $scope;
        }

        onAdd(map){
            let innerHtml = angular.element('<span id="mapBrowseText" ng-if="true" ng-bind-html="$ctrl.resultText"></span>');
            this._map = map;
            this._container = document.createElement('div');
            this._container.id = 'mapBrowseCountContainer';
            this._container.className = 'mapboxgl-ctrl-top-left map-browse-count-container mapboxgl-ctrl mapboxgl-ctrl-group hidden';
            this.$compile(innerHtml)(this.$scope);
            this._container.appendChild(innerHtml[0]);

            return this._container;
        }

        onRemove() {
            this._container.parentNode.removeChild(this._container);
            this._map = undefined;
        }
    }

    class ResultCountLoader {
        constructor($scope, $compile){
            this.$compile = $compile;
            this.$scope = $scope;
        }

        onAdd(map){
            let innerHtml = angular.element('<md-progress-linear id="mapBrowseLoader" md-mode="indeterminate"></md-progress-linear>');
            this._map = map;
            this._container = document.createElement('div');
            this._container.id = 'mapBrowseCountLoader';
            this._container.className = 'mapboxgl-ctrl-top-left map-browse-count-loader mapboxgl-ctrl mapboxgl-ctrl-group hidden';
            this.$compile(innerHtml)(this.$scope);
            this._container.appendChild(innerHtml[0]);

            return this._container;
        }

        onRemove() {
            this._container.parentNode.removeChild(this._container);
            this._map = undefined;
        }
    }

    function MwMapModalController($window, MapService, $translate, $timeout, $rootScope, $scope, $compile) {
        var mapboxgl,
            _this = this;

        this.resultCountPromise = null;
        this.MapService = MapService;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.resultText = null;

        this.mapSteps = [
            // 4x
            {
                width: 1280,
                height: 720,
                minZoom: 1.9999999999999882,
                maxZoom: 13.999999999959176
            },
            // 3.5x
            {
                width: 1120,
                height: 630,
                minZoom: 1.8073549220575866,
                maxZoom: 13.80735492201458
            },
            // 3x
            {
                width: 960,
                height: 540,
                minZoom: 1.5849625007210946,
                maxZoom: 13.584962500680282
            },
            // 2.5x
            {
                width: 800,
                height: 450,
                minZoom: 1.3219280948873442,
                maxZoom: 13.321928094843784
            },
            // 2x
            {
                width: 640,
                height: 360,
                minZoom: 0.9999999999999382,
                maxZoom: 12.999999999958886
            },
            // 1x
            {
                width: 320,
                height: 180,
                minZoom: 0,
                maxZoom: 12
            }
        ];

        this.getMapModalTitle = function getMapModalTitle() {
            return this.$translate.instant('icm-search__map-filter--modal-title');
        }.bind(this);

        this.$onChanges = function $onChanges(changes){
            if(changes.viewport && changes.viewport.currentValue && changes.viewport.currentValue.topLeft && changes.viewport.currentValue.bottomRight){
                this.viewport = changes.viewport.currentValue;
            }
        };

        this.onMapInit = function onMapInit(map) {
            mapboxgl = map;
            resizeModal();

            mapboxgl.addControl(new ResultCount($scope, $compile), 'top-left');
            mapboxgl.addControl(new ResultCountLoader($scope, $compile), 'top-left');

            if(this.resultCount){
                this.updateResultCount(this.resultCount);
            }
        }.bind(this);

        this.updateResultCount = function updateResultCount(count) {
            var resultBemKey = (count === 1) ? 'icm-search__map-filter--result-count' : 'icm-search__map-filter--results-count';

            count = (count > 500) ? '+500': count;
            count = '<b>' + count + '</b>';

            // need to pass the three trailing nulls, because the final null argument says to skip sanitization
            // otherwise translate service will escape the bold tags, and things just wont look right
            this.resultText = this.$translate.instant(resultBemKey, {itemCount: count}, null, null, null);

            //TODO - call up the loading state somewhere around here

            // return if this element is not loaded yet
            if(count || count === 0) {
                this.showContactCountComponent();
            }
        };

        this.showContactCountComponent = function showContactCountComponent() {
            var resultTextElement = document.querySelector('#mapBrowseCountContainer');
            // return if this element is not loaded yet
            if(resultTextElement){
                resultTextElement.classList.remove('hidden');
            }
        };

        this.showContactCountLoader = function showContactCountLoader() {
            this.showContactCountComponent();
            var resultLoaderElement = document.querySelector('#mapBrowseCountLoader'),
                resultTextElement = document.querySelector('#mapBrowseCountContainer');
            this.resultText = this.$translate.instant('icm-search__map-filter--results-loading');
            // return if this element is not loaded yet
            if(resultLoaderElement){
                resultLoaderElement.classList.remove('hidden');
                resultTextElement.classList.add('loading');
            }
        };

        this.hideContactCountLoader = function hideContactCountLoader() {
            var resultLoaderElement = document.querySelector('#mapBrowseCountLoader'),
                resultTextElement = document.querySelector('#mapBrowseCountContainer');
            // return if this element is not loaded yet
            if(resultLoaderElement){
                resultLoaderElement.classList.add('hidden');
                resultTextElement.classList.remove('loading');
            }
        };

        this.mapMoved = function mapMoved(){
            if(this.resultCountPromise){
                this.$timeout.cancel(this.resultCountPromise);
            }

            this.resultCountPromise = this.$timeout(()=>{
                this.showContactCountLoader();
                this.updateCount().then((res)=>{
                    this.hideContactCountLoader();
                    this.updateResultCount(res.count.toString());
                    this.resultCountPromise = null;
                });
            }, 300);
        };

        // ----------------------------------------------------
        // MODAL LOGIC
        // ----------------------------------------------------

        this.cancelModal = function cancelModal() {
            this.cancelCallback();
        };

        this.okModal = function okModal() {
            this.okCallback();
        }.bind(this);

        // ----------------------------------------------------
        // MODAL RESIZE LOGIC. MAINTAIN 16:9 ASPECT RATIO IN MAP
        // ----------------------------------------------------
        function resizeModal() {
            var windowEle = $(window),
                windowHeight = windowEle.height() * 0.8,
                windowWidth = windowEle.width() * 0.8,
                mapModalEle = $('mw-map-modal'),
                mapContainerEle = $('mw-map-modal .map-container'),
                mapHeaderHeight = $('.map-modal-header').outerHeight(),
                mapFooterHeight = $('.map-modal-footer').outerHeight(),
                bestMapWidth,
                bestMapHeight,
                mapModalHeight,
                mapStep;

            // steps are stored in descending order of size, so we just need to find the first one that
            // fits in our current window
            _this.mapSteps.some(function(step) {
                if((step.width <= windowWidth) && (step.height <= windowHeight)) {
                    mapStep = step;
                    return true;
                } else {
                    return false;
                }
            });

            bestMapWidth = mapStep.width;
            bestMapHeight = mapStep.height;
            mapModalHeight = (bestMapHeight + mapHeaderHeight + mapFooterHeight);

            _this.minZoom = mapStep.minZoom;
            _this.maxZoom = mapStep.maxZoom;

            mapModalEle.width(bestMapWidth);
            mapModalEle.height(mapModalHeight);
            mapContainerEle.width(bestMapWidth);
            mapContainerEle.height(bestMapHeight);

            if(mapboxgl) {
                var viewBounds = MapService.getViewportBounds(),
                    bounds;

                // This is where we set the max maps bounds. The minimap has set the folowing value, so we should adopt it.
                if(viewBounds) {
                    bounds = viewBounds.getBounds();
                    mapboxgl.fitBounds(bounds, {animate: false});
                } else {
                    mapboxgl.resize();
                }
                MapService.setShouldUpdateCount(true);
            }
        }

        $timeout(function() {
            resizeModal();
        }, 0);
        // ----------------------------------------------------
        // END MODAL RESIZE LOGIC.
        // ----------------------------------------------------
    }

    angular
        .module('MW.ContactManager.MwMapModal', [
            'MW.ContactManager.MwMap',
            'MW.Influencers.MapService'
        ])
        .component('mwMapModal', {
            bindings: {
                cancelCallback: '&',
                okCallback: '&',
                viewport: '<',
                resultCount: '<',
                updateCount: '&'
            },
            controller: ['$window', 'MapService', '$translate', '$timeout', '$rootScope', '$scope', '$compile', MwMapModalController],
            template: `
                <md-dialog aria-label="{{$ctrl.mapModalTitle}}">
                    <md-dialog-content layout="column">
                        <div class="map-modal-header">
                            <span>{{$ctrl.getMapModalTitle()}}</span>
                        </div>
                        <div class="map-modal-content">
                            <mw-map on-map-init="$ctrl.onMapInit(map)" viewport="$ctrl.viewport"  map-bounds-changed="$ctrl.mapMoved()" is-map-modal="true"></mw-map>
                        </div>
                    </md-dialog-content>
                    <md-dialog-actions class="map-modal-footer" layout="row">
                        <span flex></span>
                        <button class="mw-mini-modal__cancel-button mw-button md-button md-ink-ripple" type="button" ng-click="$ctrl.cancelModal()" md-autofocus="true">
                            <span translate>action-label__cancel</span>
                        </button>
                        <button class="mw-mini-modal__ok-button mw-button md-button md-ink-ripple" type="button" ng-click="$ctrl.okModal()" md-autofocus="true">
                            <span translate>OK</span>
                        </button>
                    </md-dialog-actions>
                </md-dialog>
            `
        });
}());
